namespace GeniuzPOS.InitialData {
    export interface PsShopGroupForm {
        ShopGroupId: Serenity.StringEditor;
        ShopGroupName: Serenity.StringEditor;
    }

    export class PsShopGroupForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsShopGroup';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsShopGroupForm.init)  {
                PsShopGroupForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(PsShopGroupForm, [
                    'ShopGroupId', w0,
                    'ShopGroupName', w0
                ]);
            }
        }
    }
}
